import store from '../store';

const TopMessageHandler = new class
{
    show(message: string, cssClassName: string, callback: Nullable<VoidFunction> = null, seconds: number = 5)
    {
        if (seconds < 1)
        {
            throw new Error('invalid seconds parameter');
        }

        store.commit('topMessageAdd', {
            message,
            cssClassName,
            callback,
            seconds,
        });
    }

    success(message: string, callback?: Nullable<VoidFunction>, seconds = 5)
    {
        this.show(message, 'success', callback, seconds);
    }

    error(message: string, callback?: Nullable<VoidFunction>, seconds = 15)
    {
        this.show(message, 'error', callback, seconds);
    }

    info(message: string, callback?: Nullable<VoidFunction>, seconds = 10)
    {
        this.show(message, 'info', callback, seconds);
    }
};

export default TopMessageHandler;